import React from 'react';
import { Gauge } from 'lucide-react';
import MetricGroup, { MetricField } from '../MetricGroup';
import type { StreamStats, ServerStats } from '../../../types';
import { getLevel, ThresholdLevel } from '../../../utils/thresholds';

interface Props {
  stats: StreamStats;
  serverStats: ServerStats | null;
}

const RateControl: React.FC<Props> = ({ stats, serverStats }) => {
  const sv = serverStats;
  const dominant = sv?.dominant_engine || 'default';
  const dominantData = sv?.per_engine && dominant !== 'default'
    ? (sv.per_engine as any)[dominant]
    : null;

  const bweKbps = sv?.bitrate_kbps ?? 0;
  const actualKbps = sv?.actual_encode_kbps ?? 0;
  const utilizationPct = bweKbps > 0 ? Math.round((actualKbps / bweKbps) * 100) : 0;
  const utilLevel: ThresholdLevel = bweKbps > 0
    ? getLevel('bitrate_utilization_pct', utilizationPct)
    : 'normal';

  const fields: MetricField[] = [
    { label: 'BWE 目标', value: bweKbps, unit: 'kbps' },
    { label: '实际编码', value: actualKbps, unit: 'kbps' },
    { label: '利用率', value: `${utilizationPct}`, unit: '%', level: utilLevel,
      tooltip: '<80% 黄色、<60% 红色（编码器欠码率）' },
    { label: '当前编码器', value: dominant },
  ];

  if (dominantData?.active_subscriber_count !== undefined) {
    fields.push({ label: '活跃订阅者', value: dominantData.active_subscriber_count, unit: '路' });
  }

  // 卡片整体级别 = 利用率级别
  return (
    <MetricGroup
      title="码率控制"
      icon={<Gauge size={14} />}
      level={utilLevel}
      primary={{
        label: 'BWE 利用率',
        value: bweKbps > 0 ? `${utilizationPct}%` : '—',
        level: utilLevel,
      }}
      fields={fields}
    />
  );
};

export default RateControl;
